var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet light portlet-fit" }, [
    _c("div", { staticClass: "portlet-title mb-0" }, [
      _c("div", { staticClass: "caption" }, [
        _c("i", { staticClass: "fa fa-edit" }),
        _vm._v(" "),
        _c("span", { staticClass: "caption-subject bold uppercase" }, [
          _c("span", [
            _vm._v(
              "Saisie des ventes pour " + _vm._s(_vm.customer.customer_name)
            )
          ]),
          _vm._v(" "),
          _vm.customer.customer_has_commission
            ? _c(
                "span",
                {
                  staticClass: "badge badge-primary",
                  staticStyle: { "font-weight": "bold" }
                },
                [_vm._v("Commission")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.customer.customer_has_paycomplete
            ? _c(
                "span",
                {
                  staticClass: "badge badge-success bg-green-jungle",
                  staticStyle: { "font-weight": "bold" }
                },
                [_vm._v("PayComplete")]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "a",
          {
            staticClass: "btn pull-right red ml-2",
            attrs: { href: "javascript:;" },
            on: {
              click: function($event) {
                return _vm.detail()
              }
            }
          },
          [_vm._v("\n          Fiche du client\n        ")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            class: _vm.saveButtonClasses,
            attrs: { href: "javascript:;", disabled: "" }
          },
          [
            _vm.saving
              ? _c("span", [
                  _c("span", { staticClass: "fa fa-save" }),
                  _vm._v(" Sauvegarde en cours...\n          ")
                ])
              : !_vm.hasChanges && !_vm.savedAtLeastOnce
              ? _c("span", [
                  _c("span", { staticClass: "fa fa-clock-o" }),
                  _vm._v(" Aucun changement\n          ")
                ])
              : _vm.hasChanges
              ? _c("span", [
                  _c("span", { staticClass: "fa fa-pencil" }),
                  _vm._v(" changements en cours... "),
                  _vm.timeBeforeSave > 0
                    ? _c("span", [
                        _vm._v("(" + _vm._s(_vm.timeBeforeSave) + ")")
                      ])
                    : _vm._e()
                ])
              : !_vm.hasChanges && _vm.savedAtLeastOnce
              ? _c("span", [
                  _c("span", { staticClass: "fa fa-check" }),
                  _vm._v(" Changements sauvegardés\n          ")
                ])
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("date-picker", {
            staticClass: "pull-right mr-2",
            attrs: {
              "default-date": _vm.selectedDate,
              placeholder: _vm.datePickerPlaceholder,
              "placeholder-format": _vm.datePickerPlaceholderFormat,
              disabled: _vm.saving || _vm.hasChanges
            },
            model: {
              value: _vm.selectedDate,
              callback: function($$v) {
                _vm.selectedDate = $$v
              },
              expression: "selectedDate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "pull-right btn mr-2",
          class: { "green-jungle": _vm.showDetails, red: !_vm.showDetails },
          staticStyle: { width: "50px" },
          on: {
            click: function($event) {
              _vm.showDetails = !_vm.showDetails
            }
          }
        },
        [
          _vm.showDetails
            ? _c("span", [_c("i", { staticClass: "fa fa-check-square-o" })])
            : _vm._e(),
          _vm._v(" "),
          !_vm.showDetails
            ? _c("span", [_c("i", { staticClass: "fa fa-square-o" })])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.hasInvalidNewValues
        ? _c(
            "div",
            {
              staticClass: "pull-right",
              staticStyle: { padding: "6px", color: "red" }
            },
            [
              _vm._v(
                "\n        La nouvelle valeur doit être supérieure ou égale à l'ancienne valeur.\n      "
              )
            ]
          )
        : _vm.hasInvalidCashEval
        ? _c(
            "div",
            {
              staticClass: "pull-right",
              staticStyle: { padding: "6px", color: "red" }
            },
            [
              _vm._v(
                "\n        Veuillez corriger les erreurs d'expression dans la case « Argent reçu »\n      "
              )
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "portlet-body p-0",
        staticStyle: { "overflow-x": "scroll" }
      },
      [
        _c("table", { staticClass: "table table-bordered mb-0" }, [
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v("Machine")]),
              _vm._v(" "),
              _c("th", [_vm._v("Ancienne valeur")]),
              _vm._v(" "),
              _c("th", [_vm._v("Nouvelle valeur")]),
              _vm._v(" "),
              _c("th", [_vm._v("Différence")]),
              _vm._v(" "),
              _c("th", [_vm._v("Moins correction")]),
              _vm._v(" "),
              _c("th", [_vm._v("Diff après correction")]),
              _vm._v(" "),
              _c("th", [_vm._v("Argent reçu")]),
              _vm._v(" "),
              _vm.showDetails
                ? _c("th", { staticStyle: { "background-color": "#9acee4" } }, [
                    _vm._v("Argent reçu calculé")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showDetails
                ? _c("th", { staticStyle: { "background-color": "#9acee4" } }, [
                    _vm._v("Argent reçu PayComplete")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("th", [_vm._v("Argent reçu total")]),
              _vm._v(" "),
              _c("th", [_vm._v("Diff. d'argent")]),
              _vm._v(" "),
              _c("th", { staticStyle: { "background-color": "#84e680" } }, [
                _vm._v("Diff. $ cumul.")
              ]),
              _vm._v(" "),
              _c(
                "th",
                { staticStyle: { "white-space": "nowrap", width: "1%" } },
                [_vm._v("Commission (%)")]
              ),
              _vm._v(" "),
              _c(
                "th",
                { staticStyle: { "white-space": "nowrap", width: "1%" } },
                [_vm._v("Correction (%)")]
              ),
              _vm._v(" "),
              _c(
                "th",
                { staticStyle: { "white-space": "nowrap", width: "1%" } },
                [_vm._v("Commission")]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.customer.machines !== undefined &&
          _vm.customer.machines.length > 0
            ? _c(
                "tbody",
                _vm._l(_vm.customer.machines, function(machine, index) {
                  return _c(
                    "tr",
                    {
                      key: index,
                      class: { inactive: machine.machine_active == 0 }
                    },
                    [
                      _c("td", { style: _vm.machineTdStyles(machine) }, [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.excelSales(machine.machine_id)
                              }
                            }
                          },
                          [_c("span", { staticClass: "fa fa-file-excel-o" })]
                        ),
                        _vm._v(
                          " " + _vm._s(machine.machine_name) + "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: machine.sales.sales_value_old,
                              expression: "machine.sales.sales_value_old",
                              modifiers: { number: true }
                            }
                          ],
                          ref: "sales_value_old",
                          refInFor: true,
                          staticClass: "form-control",
                          attrs: { type: "number" },
                          domProps: { value: machine.sales.sales_value_old },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  machine.sales,
                                  "sales_value_old",
                                  _vm._n($event.target.value)
                                )
                              },
                              function($event) {
                                return _vm.computeValueDifference(machine.sales)
                              }
                            ],
                            keypress: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.focusNextMachine("sales_value_old")
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: machine.sales.sales_value_new,
                              expression: "machine.sales.sales_value_new",
                              modifiers: { number: true }
                            }
                          ],
                          ref: "sales_value_new",
                          refInFor: true,
                          staticClass: "form-control",
                          class: {
                            is_invalid: _vm.machineOldValueIsNotValid(machine)
                          },
                          attrs: { type: "number" },
                          domProps: { value: machine.sales.sales_value_new },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  machine.sales,
                                  "sales_value_new",
                                  _vm._n($event.target.value)
                                )
                              },
                              function($event) {
                                return _vm.computeValueDifference(machine.sales)
                              }
                            ],
                            keypress: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.focusNextMachine("sales_value_new")
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: machine.sales.sales_value_difference,
                              expression:
                                "machine.sales.sales_value_difference",
                              modifiers: { number: true }
                            }
                          ],
                          ref: "sales_value_difference",
                          refInFor: true,
                          staticClass: "form-control",
                          attrs: {
                            type: "number",
                            readonly: "",
                            tabindex: "-1"
                          },
                          domProps: {
                            value: machine.sales.sales_value_difference
                          },
                          on: {
                            keypress: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.focusNextMachine(
                                "sales_value_difference"
                              )
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                machine.sales,
                                "sales_value_difference",
                                _vm._n($event.target.value)
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: machine.sales.sales_value_correction,
                              expression:
                                "machine.sales.sales_value_correction",
                              modifiers: { number: true }
                            }
                          ],
                          ref: "sales_value_correction",
                          refInFor: true,
                          staticClass: "form-control",
                          attrs: { type: "number" },
                          domProps: {
                            value: machine.sales.sales_value_correction
                          },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  machine.sales,
                                  "sales_value_correction",
                                  _vm._n($event.target.value)
                                )
                              },
                              function($event) {
                                return _vm.computeValueDifferenceAfterCorrection(
                                  machine.sales
                                )
                              }
                            ],
                            keypress: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.focusNextMachine(
                                "sales_value_correction"
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value:
                                machine.sales
                                  .sales_value_difference_after_correction,
                              expression:
                                "machine.sales.sales_value_difference_after_correction",
                              modifiers: { number: true }
                            }
                          ],
                          ref: "sales_value_difference_after_correction",
                          refInFor: true,
                          staticClass: "form-control",
                          attrs: {
                            type: "number",
                            readonly: "",
                            tabindex: "-1"
                          },
                          domProps: {
                            value:
                              machine.sales
                                .sales_value_difference_after_correction
                          },
                          on: {
                            keypress: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.focusNextMachine(
                                "sales_value_difference_after_correction"
                              )
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                machine.sales,
                                "sales_value_difference_after_correction",
                                _vm._n($event.target.value)
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: machine.sales.sales_cash_received_equation,
                              expression:
                                "machine.sales.sales_cash_received_equation"
                            }
                          ],
                          ref: "sales_cash_received_equation",
                          refInFor: true,
                          staticClass: "form-control",
                          class: { is_invalid: machine.sales.eval_has_errors },
                          attrs: { type: "text" },
                          domProps: {
                            value: machine.sales.sales_cash_received_equation
                          },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  machine.sales,
                                  "sales_cash_received_equation",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                return _vm.computeCashDifference(machine.sales)
                              }
                            ],
                            change: _vm.formatAllToTwoDecimals,
                            keypress: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.focusNextMachine(
                                "sales_cash_received_equation"
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.showDetails
                        ? _c("td", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value:
                                    machine.sales
                                      .sales_cash_received_calculated,
                                  expression:
                                    "machine.sales.sales_cash_received_calculated",
                                  modifiers: { number: true }
                                }
                              ],
                              ref: "sales_cash_received_calculated",
                              refInFor: true,
                              staticClass: "form-control",
                              staticStyle: { "background-color": "#c5e5f3" },
                              attrs: {
                                type: "number",
                                readonly: "",
                                tabindex: "-1"
                              },
                              domProps: {
                                value:
                                  machine.sales.sales_cash_received_calculated
                              },
                              on: {
                                keypress: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.focusNextMachine(
                                    "sales_cash_received_calculated"
                                  )
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    machine.sales,
                                    "sales_cash_received_calculated",
                                    _vm._n($event.target.value)
                                  )
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showDetails
                        ? _c("td", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value:
                                    machine.sales
                                      .sales_cash_received_paycomplete_report,
                                  expression:
                                    "machine.sales.sales_cash_received_paycomplete_report",
                                  modifiers: { number: true }
                                }
                              ],
                              ref: "sales_cash_received_paycomplete_report",
                              refInFor: true,
                              staticClass: "form-control",
                              staticStyle: { "background-color": "#c5e5f3" },
                              attrs: {
                                type: "number",
                                readonly: "",
                                tabindex: "-1"
                              },
                              domProps: {
                                value:
                                  machine.sales
                                    .sales_cash_received_paycomplete_report
                              },
                              on: {
                                keypress: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.focusNextMachine(
                                    "sales_cash_received_paycomplete_report"
                                  )
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    machine.sales,
                                    "sales_cash_received_paycomplete_report",
                                    _vm._n($event.target.value)
                                  )
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: machine.sales.sales_cash_received_total,
                              expression:
                                "machine.sales.sales_cash_received_total",
                              modifiers: { number: true }
                            }
                          ],
                          ref: "sales_cash_received_total",
                          refInFor: true,
                          staticClass: "form-control",
                          attrs: {
                            type: "number",
                            readonly: "",
                            tabindex: "-1"
                          },
                          domProps: {
                            value: machine.sales.sales_cash_received_total
                          },
                          on: {
                            keypress: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.focusNextMachine(
                                "sales_cash_received_total"
                              )
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                machine.sales,
                                "sales_cash_received_total",
                                _vm._n($event.target.value)
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: machine.sales.sales_cash_difference,
                              expression: "machine.sales.sales_cash_difference",
                              modifiers: { number: true }
                            }
                          ],
                          ref: "sales_cash_difference",
                          refInFor: true,
                          staticClass: "form-control",
                          attrs: {
                            type: "number",
                            readonly: "",
                            tabindex: "-1"
                          },
                          domProps: {
                            value: machine.sales.sales_cash_difference
                          },
                          on: {
                            keypress: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.focusNextMachine(
                                "sales_cash_difference"
                              )
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                machine.sales,
                                "sales_cash_difference",
                                _vm._n($event.target.value)
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          ref: "machine_cash_difference_cumulative",
                          refInFor: true,
                          staticClass: "form-control",
                          staticStyle: { "background-color": "#c7f3c5" },
                          attrs: {
                            type: "number",
                            readonly: "",
                            tabindex: "-1"
                          },
                          domProps: {
                            value: _vm.machineCashCumulativeDifference(machine)
                          },
                          on: {
                            keypress: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.focusNextMachine(
                                "machine_cash_difference_cumulative"
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: machine.sales.sales_commission_percent,
                              expression:
                                "machine.sales.sales_commission_percent",
                              modifiers: { number: true }
                            }
                          ],
                          ref: "sales_commission_percent",
                          refInFor: true,
                          staticClass: "form-control",
                          attrs: { type: "number" },
                          domProps: {
                            value: machine.sales.sales_commission_percent
                          },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  machine.sales,
                                  "sales_commission_percent",
                                  _vm._n($event.target.value)
                                )
                              },
                              function($event) {
                                return _vm.computeCommission(machine.sales)
                              }
                            ],
                            keypress: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.focusNextMachine(
                                "sales_commission_percent"
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: machine.sales.sales_correction_percent,
                              expression:
                                "machine.sales.sales_correction_percent",
                              modifiers: { number: true }
                            }
                          ],
                          ref: "sales_correction_percent",
                          refInFor: true,
                          staticClass: "form-control",
                          attrs: { type: "number" },
                          domProps: {
                            value: machine.sales.sales_correction_percent
                          },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  machine.sales,
                                  "sales_correction_percent",
                                  _vm._n($event.target.value)
                                )
                              },
                              function($event) {
                                return _vm.computeCommission(machine.sales)
                              }
                            ],
                            keypress: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.focusNextMachine(
                                "sales_correction_percent"
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: machine.sales.sales_commission,
                              expression: "machine.sales.sales_commission",
                              modifiers: { number: true }
                            }
                          ],
                          ref: "sales_commission",
                          refInFor: true,
                          staticClass: "form-control",
                          attrs: {
                            type: "number",
                            readonly: "",
                            tabindex: "-1",
                            step: "0.01"
                          },
                          domProps: { value: machine.sales.sales_commission },
                          on: {
                            keypress: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.focusNextMachine("sales_commission")
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                machine.sales,
                                "sales_commission",
                                _vm._n($event.target.value)
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ])
                    ]
                  )
                }),
                0
              )
            : _c("tbody", [
                _c(
                  "td",
                  { staticClass: "text-center p-2", attrs: { colspan: "11" } },
                  [
                    _vm._v(
                      "\n            Ce client n'a aucune machine.\n          "
                    )
                  ]
                )
              ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }